export default { sha: 'b2f153ecaf15c99450f4ab5d433ba92591919f7c', buildNumber: 'undefined' }
